export default __webpack_public_path__ + "static/media/top-tips.9c21fa1b.png";